import { alpha } from '@mui/material/styles';
import { Components, Theme } from '@mui/material/styles';

/**
 * Owns the shape and the selected tint for every list item in the app.
 *
 * The active marker used to be a 3px left border on the button itself, which
 * shifted the label 3px whenever an item became active. The design instead puts
 * a short rail *inside* the item, so every label sits on the same optical left
 * edge in both states — see `Sidebar`'s `NavItem`, which renders it.
 */
export const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      border: '1px solid transparent',
      margin: '2px 8px',
      width: 'calc(100% - 16px)',
      transition:
        'background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease',
      '&:hover': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.mode === 'dark' ? 0.08 : 0.06
        ),
        borderColor: theme.palette.studio.borders.hairline,
        boxShadow: theme.palette.studio.shadows.cardFlat,
      },
      '&.Mui-selected': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.mode === 'dark' ? 0.13 : 0.1
        ),
        borderColor: theme.palette.studio.borders.subtle,
        boxShadow: theme.palette.studio.shadows.cardFlat,
        // The accent lives in the rail and the tint, not the text. Orange type
        // on an orange wash was the weakest contrast pairing on the screen.
        color: theme.palette.text.primary,
        '& .MuiListItemIcon-root': {
          color: theme.palette.text.primary,
        },
        '&:hover': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.mode === 'dark' ? 0.16 : 0.14
          ),
        },
      },
    }),
  },
};
